import styled, { css } from 'styled-components/macro'
import { BaseColor, border, Icon, linkReset, rem, spacing, themeColor, transitions, Typography } from '@unbounded/unbounded-components'
import { Link as RouterLink } from 'react-router-dom'

export const Container = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

export const LinksList = styled.div`
  flex: 0 0 auto;
  display: flex;
  width: 100%;
  border-bottom: ${border};
`

interface StyledLinkProps {
  $isActive?: boolean
}

const linkActiveStyles = css`
  color: ${themeColor(BaseColor.shade_80)};

  &::after {
    background-color: ${themeColor(BaseColor.shade_90)};
  }
`

export const Link = styled(RouterLink)<StyledLinkProps>`
  ${linkReset};
  position: relative;
  padding: 0 ${rem(10)} ${rem(11)};

  ${Typography.labelLarge};
  ${Typography.textSemiStrong};

  color: ${themeColor(BaseColor.shade_60)};
  ${transitions(['color'])};

  &:hover {
    color: ${themeColor(BaseColor.shade_70)};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: ${rem(10)};
    right: ${rem(10)};
    height: 1px;
    background-color: transparent;
    ${transitions(['background-color'])};
  }

  &:first-of-type {
    padding-left: 0;

    &::after {
      left: 0;
    }
  }

  &:last-of-type {
    padding-right: 0;

    &::after {
      right: 0;
    }
  }

  ${({ $isActive }) => $isActive && linkActiveStyles};

  &.active {
    ${linkActiveStyles};
  }
`

export const LinkIcon = styled(Icon)`
  margin-right: ${spacing(0.25)};
`

export const Content = styled.div`
  margin-top: ${spacing()};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`
